"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _coreConditionActions = require("./coreConditionActions");
var _coreConfirmActions = require("./coreConfirmActions");
var _coreFontActions = require("./coreFontActions");
var _coreInfoBarActions = require("./coreInfoBarActions");
var _coreLocaleActions = require("./coreLocaleActions");
var _coreLoginInfoActions = require("./coreLoginInfoActions");
/**
 * 共通のreducer群。
 * reducerを追加したら、ここにも追加すること。
 */
const coreReducers = {
  coreConfirm: _coreConfirmActions.coreConfirmReducer,
  coreFont: _coreFontActions.coreFontReducer,
  coreInfoBar: _coreInfoBarActions.coreInfoBarReducer,
  coreLocale: _coreLocaleActions.coreLocaleReducer,
  coreLoginInfo: _coreLoginInfoActions.coreLoginInfoReducer,
  coreCondition: _coreConditionActions.coreConditionReducer
};
var _default = exports.default = coreReducers;